













import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import Modal from "./Modal.vue";
import Accordion from "./Accordion.vue";

@Component({
  components: {
    Modal
  }
})
export default class AdvanceInfoModal extends Vue {
  open: boolean = true;

  getMaxRefundAmount() {
    const metaElement = document.querySelector('meta[name=max-admin-fee]');
    if (metaElement) {
      return parseInt(metaElement.getAttribute('content'));
    }
    return 10;
  }
}
